import {listOpeningHours} from '../../../utils/utils.jsx'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {address as textsAddress} from '../../../translate/Translate.jsx'
import {motion} from 'framer-motion'
import './openingHours.scss'

const OpeningHours = ({weekDeliveryStore, weekShopStore, weekDeliveryRoute}) => {
    const modules = getLocal('modules')
    const listWeeksDelivery = listOpeningHours(weekDeliveryStore, false)
    const listWeeksShop = listOpeningHours(weekShopStore, false)
    const listWeekDeliveryRoute = listOpeningHours(weekDeliveryRoute, true)

    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'opening-hours'}>
            {(modules !== 2 && modules !== 3 && modules !== 4) && <div className={'items'}>
                <label className={'title'}>
                    {textsAddress.delivery}
                </label>
                {listWeeksDelivery.map((l, i) => <div key={i} className={'div-content-item'}>
                    <label className={'day'} id={l.currentDay ? 'current-day' : ''}>
                        {l.day}
                    </label>
                    <label className={'times'} id={l.currentDay ? 'current-day' : ''}>
                        {!!l.times.trim() ? l.times : 'Fechado'}
                    </label>
                </div>)}
            </div>}
            {(modules === 3 || modules === 4) && <div className={'items'}>
                <label className={'title'}>
                    {textsAddress.deliveryRoute}
                </label>
                {listWeekDeliveryRoute.map((l, i) => <div key={i} className={'div-content-item'}>
                    <label className={'day'} id={l.currentDay ? 'current-day' : ''}>
                        {l.day}
                    </label>
                    <label className={'times'} id={l.currentDay ? 'current-day' : ''}>
                        {l.times}
                    </label>
                </div>)}
            </div>}
            {(modules !== 1 && modules !== 3) && <div className={'items'}>
                <label className={'title'}>
                    {textsAddress.takeaway}
                </label>
                {listWeeksShop.map((l, i) => <div key={i} className={'div-content-item'}>
                    <label className={'day'} id={l.currentDay ? 'current-day' : ''}>
                        {l.day}
                    </label>
                    <label className={'times'} id={l.currentDay ? 'current-day' : ''}>
                        {!!l.times.trim() ? l.times : 'Fechado'}
                    </label>
                </div>)}
            </div>}
        </div>
    </motion.div>
}

export default OpeningHours
